<div class="tab-data-container">
	@if (!requestData.history || requestData.history.length === 0) {
		<div class="history">
			{{ labels.lbl_no_group_change }}
		</div>
	}
	@for (history of requestData.history; track $index) {
		<div class="history">
			<span
				><strong>{{ labels.lbl_geral_grupo }}</strong
				>: {{ history.group }}</span
			>
			<span
				><strong>{{ labels.lbl_geral_competencia }}</strong
				>: {{ history.scope }}</span
			>
			<span
				><strong>{{ labels.lbl_asset_category }}</strong
				>: {{ history.category }}</span
			>
			<span
				><strong>{{ labels.lbl_geral_topico }}</strong
				>: {{ history.topic }}</span
			>
			<span
				><strong>{{ labels.lbl_geral_urgencia }}</strong
				>: {{ history.urgency }}</span
			>
			<span
				><strong>{{ labels.lbl_geral_impacto }}</strong
				>: {{ history.riskImpact }}</span
			>
			<span
				><strong>{{ labels.lbl_inicio_da_categorizacao }}</strong
				>: {{ history.start !== '' ? dateService.formatDate(history.start) : '' }}</span
			>
			<span
				><strong>{{ labels.lbl_termino_da_categorizacao }}</strong
				>: {{ history.end !== '' ? dateService.formatDate(history.end) : labels.lbl_boletim_em_andamento }}</span
			>
			@if (history.slaViolation === SLA_VIOLATION.DENTRO_DO_PRAZO.toString()) {
				<span><strong>SLA</strong>: {{ labels.lbl_geral_no_prazo }}</span>
			}
			@if (history.slaViolation === SLA_VIOLATION.FORA_DO_PRAZO.toString()) {
				<span><strong>SLA</strong>: {{ labels.lbl_geral_fora_prazo }}</span>
			}
		</div>
	}
</div>
